import AvataUpload from "components/AvataUpload";
import {
  Button,
  Col,
  DatePicker,
  Form,
  FormInstance,
  Input,
  Row,
  Select,
  Tooltip,
  Typography,
} from "antd";
import React, { FC, useEffect, useMemo, useState } from "react";
import styled from "@emotion/styled";
import locale from "antd/es/date-picker/locale/th_TH";
import TextArea from "antd/es/input/TextArea";
import { useTestMessagingLine } from "hooks/useLine";
import { testMessagingLine } from "services/lineApi";
import { DataTokenLine } from "services/interface";
import { InfoOutlined } from "@ant-design/icons";
// import SettingAvatar from "./SettingAvatar";

interface SettingLineAlertFormProps {
  form: FormInstance;
  onFinish: (values: any) => void;
  data: DataTokenLine | undefined;
//   avatar: any;
}

const SettingLineAlertForm: FC<SettingLineAlertFormProps> = ({
  form,
  onFinish,
  data,
//   avatar,
}) => {


  const handleTestMessaging = () => {
    testMessagingLine();
  };


  return (
    <>
      <Form
        form={form}
        onFinish={onFinish}
        labelCol={{ span: 4 }}
        wrapperCol={{ span: 24 }}
      >
        {/* <Row style={{ marginBottom: 20 }}>
          <Typography.Text>วิธีการขอรับ Line Token</Typography.Text>
        </Row> */}
        <Form.Item
          name="channelId"
          labelAlign="left"
          label={
            <Row align="middle">
              <span>Channel Id</span>
              <Tooltip placement="topLeft" title={"Channel Id สามารถรับได้จาก https://developers.line.biz"}>
                <Button shape="circle" style={{ marginLeft: 8 }}>
                  <InfoOutlined />
                </Button>
              </Tooltip>
            </Row>
          }          
         // rules={[{ required: true, message: "กรุณากรอก Channel Id" }]}
        >
            <Input placeholder="Channel Id"  /> 
        </Form.Item>
        <Form.Item
          name="liffId"
          labelAlign="left"
          label={
            <Row align="middle">
              <span>Liff Id</span>
              <Tooltip placement="topLeft" title={"Liff Id สามารถรับได้จาก https://developers.line.biz"}>
                <Button shape="circle" style={{ marginLeft: 8 }}>
                  <InfoOutlined />
                </Button>
              </Tooltip>
            </Row>
          }   
         // rules={[{ required: true, message: "กรุณากรอก Liff Id" }]}
        >
            <Input placeholder="Liff Id"  /> 
        </Form.Item>
        <Form.Item
          name="token"
          labelAlign="left"
          label={
            <Row align="middle">
              <span>Line Notify Token</span>
              <Tooltip placement="topLeft" title={"Token สามารถรับได้จาก https://developers.line.biz"} >
                <Button shape="circle" style={{ marginLeft: 8 }}>
                  <InfoOutlined />
                </Button>
              </Tooltip>
            </Row>
          }   
          // rules={[{ required: true, message: "กรุณากรอก line token" }]}
        >
            <TextArea rows={4} placeholder="Line Notify Token"  /> 
        </Form.Item>
        <Form.Item
          name="line_oa_token"
          labelAlign="left"
          label={
            <Row align="middle">
              <span>Line OA Token</span>
              <Tooltip placement="topLeft" title={"Token สามารถรับได้จาก https://developers.line.biz"} >
                <Button shape="circle" style={{ marginLeft: 8 }}>
                  <InfoOutlined />
                </Button>
              </Tooltip>
            </Row>
          }   
          // rules={[{ required: true, message: "กรุณากรอก line token" }]}
        >
            <TextArea rows={4} placeholder="Line OA Token"  /> 
        </Form.Item>
        {/* <Form.Item
          name="token_notify_token"
          labelAlign="left"
          label={
            <Row align="middle">
              <span>Line Notify Token</span>
              <Tooltip placement="topLeft" title={"Token สามารถรับได้จาก https://developers.line.biz"} >
                <Button shape="circle" style={{ marginLeft: 8 }}>
                  <InfoOutlined />
                </Button>
              </Tooltip>
            </Row>
          }   
          // rules={[{ required: true, message: "กรุณากรอก line token" }]}
        >
            <TextArea rows={4} placeholder="Line Notify Token"  /> 
        </Form.Item>        */}
        <Form.Item>
          <WrapperButton>     
                   
            <Button
              style={{ width: 250, marginRight:"10px" }}
              className="product-btn"
              size="large"
              onClick={handleTestMessaging}
              disabled={!data} 
            >
              ส่งข้อความทดสอบ
            </Button>
            <Button
              style={{ width: 250, marginRight:"10px"}}
              type="primary"
              size="large"
              htmlType="submit"
            >
              บันทึก
            </Button>
          </WrapperButton>
        </Form.Item>
      </Form>
    </>
  );
};

export default SettingLineAlertForm;

const WrapperAvata = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 40px;
  width: 130px;
  height: auto;
  margin-left: auto;
  margin-right: auto;
`;

const WrapperButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  margin-top: 20px;
  width: 100%;
`;
